import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.scss']
})
export class ParkingComponent extends SeoAwareBaseComponent implements OnInit {
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Parcare in proiectul Dream Residence');
    this.setMetaDescription(
      `Nu iti vei mai pune niciodata problema daca ai unde sa parchezi sau nu. Conceptul Dream Residence pune la dispozitie atat parcari subterane, cat si supraterane.`
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/parking/parking.component.ts